export { TranslatesBrowserModule } from './translates-browser.module';
